module.exports = __webpack_public_path__ + "img/logo.6507cdff.png";